/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

export enum PaymentConnectorPostMessageType {
    CardPrefix = 'msax-cc-cardprefix',
    Error = 'msax-cc-error',
    Height = 'msax-cc-height',
    Result = 'msax-cc-result',
    Submit = 'msax-cc-submit',
    ExtraContext = 'msax-cc-extracontext',
    Redirect = 'msax-cc-redirect',
    Showoverlay = 'msax-cc-showoverlay',
    Hideoverlay = 'msax-cc-hideoverlay'
}

export interface IPaymentConnectorPostMessage {
    message: string;
    targetOrigin: string;
}

export function paymentConnectorMessage(data: string, messageType: PaymentConnectorPostMessageType): IPaymentConnectorPostMessage {
    return {
        message: JSON.stringify({
            type: messageType,
            value: data
        }),
        targetOrigin: '*'
    };
}

// TODO: Strongly type input data to AdditionalContext
export function paymentConnectorExtraContextMessage(data: string): IPaymentConnectorPostMessage {
    return paymentConnectorMessage(data, PaymentConnectorPostMessageType.ExtraContext);
}

export function paymentConnectorSubmitMessage(): IPaymentConnectorPostMessage {
    return paymentConnectorMessage('true', PaymentConnectorPostMessageType.Submit);
}
